function isPortrait() {
  return window.innerHeight > window.innerWidth
}

const getOrientation = () => {
  if (isMobile() && !window.screen.orientation) {
    if (isPortrait()) {
      return "portrait"
    } else {
      return "landscape"
    }
  }

  const orientation =
    (window.screen.orientation || {}).type ||
    window.screen.mozOrientation ||
    window.screen.msOrientation
  return orientation === "portrait-secondary" ||
    orientation === "portrait-primary"
    ? "portrait"
    : "landscape"
}

const isMobile = () => {
  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(
      navigator.userAgent
    )
  ) {
    return true
  }
  return false
}

const parseJWT = (token) => {
  try {
    return JSON.parse(atob(token.split(".")[1]))
  } catch (e) {
    return null
  }
}

const getOktaAccessToken = () => {
  const localStorageToken =
    JSON.parse(localStorage.getItem("okta-token-storage")) || {}

  return (localStorageToken.accessToken || {}).accessToken
}

export const getQueryStringValue = (str, key) => {
  return decodeURIComponent(
    str.replace(
      new RegExp(
        "^(?:.*[&\\?]" +
          encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") +
          "(?:\\=([^&]*))?)?.*$",
        "i"
      ),
      "$1"
    )
  )
}

export const checkIsMobile = () => {
  return {
    isMobile: isMobile(),
    isLandscape: getOrientation() === "landscape",
  }
}

export const getOktaInfo = () => {
  const localStorageIdToken =
    JSON.parse(localStorage.getItem("okta-token-storage")) || {}

  const { idToken } = localStorageIdToken

  if (idToken) {
    const parsedToken = parseJWT(idToken.idToken)
    if (parsedToken) {
      return {
        groups: parsedToken.groups || [],
        name: parsedToken.name,
        email: parsedToken.email,
        payload: parsedToken,
      }
    }
    return false
  }

  return false
}

export const verifyOktaToken = () => {
  return fetch(`https://nesterra.okta.com/oauth2/default/v1/userinfo`, {
    headers: {
      Authorization: `Bearer ${getOktaAccessToken()}`,
    },
  }).catch((err) => {
    localStorage.clear()
    window.location.href = "/login"
  })
}



// WEBPACK FOOTER //
// ./src/utils.js